import {Injectable} from '@angular/core';
import {StepProviderImpl, Step} from '@pes/ui';
import {StepLbpaType} from '../../enum/step-lbpa-type.enum';
import { ParcoursLbpaStep } from '../../step/parcours-lbpa.step';

/**
 * The custom StepProvider implementation that provides custom steps.
 */
@Injectable()
export class AppStepProvider extends StepProviderImpl {

    /**
     * @inheritDoc
     */
    public getStep(step: any): Step {
        switch (step.type) {
            case StepLbpaType.SIGNATURE_PARCOURS_LBPA:
                return new ParcoursLbpaStep(step);
        }
        return super.getStep(step);
    }
}



// WEBPACK FOOTER //
// ./src/app/config/provider/app.step-provider.ts